import { all, takeLatest, call, put, select } from "redux-saga/effects";
import { API_URL } from "../../../utils/axios";
import * as api from "../../../utils/api";
import { createGoalDLSuccess, createGoalDLFailed, getDeeplink4ConfigSuccess, getDeeplink4ConfigFailed } from "./action";
import { CREATE_GOAL_DL, GET_CGOAL_DL, DL_CHECKOUT, GET_DEEPLINK_4_CONFIG } from "./constants";
import {
  getcGoalDLSuccess,
  getcGoalDLFailed,
  deeplinkCheckoutSuccess,
  deeplinkCheckoutFailed,
} from "./action";
import { v4 as uuidv4 } from "uuid";
import { CS_00071 } from "../../../utils/errorCodes";

function* createGoalDL({ payload, callback }) {
  let err;
  try {
    const masterId = yield select(state => {
      if (state.goal.profile && state.goal.profile.masterId) {
        return state.goal.profile.masterId;
      }
      return null;
    });

    const { passWholeResponse, ...rest } = payload;

    const res = yield call(api.post, `${API_URL.mp}/smp/goal-creation`, {
      ...rest,
      cifId: masterId,
    });
    const { data } = res;

    yield put(createGoalDLSuccess(data));

    if (passWholeResponse) {
      callback(data);
    } else {
      callback(data.accountNo);
    }
  } catch (error) {
    err = error;
    yield put(createGoalDLFailed(error));
  } finally {
    if (
      typeof callback === "function" &&
      payload.hasOwnProperty("passWholeResponse") &&
      err instanceof Object &&
      err.hasOwnProperty("errorCode") &&
      err.errorCode === CS_00071
    ) {
      callback("uneligible-age-to-retire");
    }
  }
}

function* getCGoalDLSaga({ payload }) {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/goal-creation/${payload}`
    );
    const { data } = res;

    yield put(getcGoalDLSuccess(data));
  } catch (error) {
    yield put(getcGoalDLFailed());
  }
}

function* deeplinkChekoutSaga({ payload }) {
  try {
    const {
      customerChannelCode,
      amount,
      ccy,
      name,
      email,
      cifId,
      cifPlanId,
      campaignCode,
      productId,
      funds,
      source,
      sourceType,
    } = payload;

    const checkoutPayload = {
      cifPlanId,
      campaignCode,
      trxType: "FPX",
      unit: 0,
      feePercent: 0,
      feeCcy: "MYR",
      feeAmount: 0,
      paymentTypeCd: "",
      ppgRefNo: "",
      pgRefNo: "",
      type: "",
      status: "",
      funds,
      source,
      sourceType,
    };

    const resCheckout = yield call(
      api.post,
      `${API_URL.mpV2}/checkout`,
      checkoutPayload
    );

    const trxRefNo = resCheckout?.data?.trxRefNo;

    const generatePayload = {
      trxRefNo,
      cifID: cifId,
      customerChannelCode,
      name,
      email,
      amount,
      ccy,
    };

    const resGenerate = yield call(
      api.post,
      `${API_URL.ppg}/payment/generate`,
      generatePayload
    );

    const { data } = resGenerate;

    const ppgPostDirect = {
      customerChannelCode,
      payCatCd: null,
      trxRefNo,
      amount,
      ccy,
      cifID: cifId,
      refId: trxRefNo.slice(2, trxRefNo.length),
      name,
      email,
      lang: "en",
      signature: data.signature,
      resUrl: `${API_URL.mp}/webhooks/res-url`, // to redirect back to mp
      backUrl: `${API_URL.backURL}`,
    };

    // Data input to ppg
    const myForm = document.createElement("form");
    myForm.method = "POST";
    myForm.id = "Payform";
    myForm.action = `${API_URL.ppg}/entry`;
    // myForm.action = `${API_URL.ppgLocal}`; // try on local
    for (const key in ppgPostDirect) {
      if (Object.hasOwnProperty.call(ppgPostDirect, key)) {
        const element = ppgPostDirect[key];
        const myInput = document.createElement("input");
        myInput.type = "hidden";
        myInput.name = key;
        myInput.id = key;
        myInput.value = element;
        myForm.appendChild(myInput);
      }
    }
    document.body.appendChild(myForm);

    yield put(deeplinkCheckoutSuccess());

    myForm.submit();
  } catch (error) {
    yield put(deeplinkCheckoutFailed(error));
  }
}

function* getDeeplink4ConfigSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/deeplink_4_config`
    );
    const { data } = res;

    yield put(getDeeplink4ConfigSuccess(data));
  } catch (error) {
    yield put(getDeeplink4ConfigFailed());
  }
}

export function* deeplinkWorkerSaga() {
  yield all([
    takeLatest(CREATE_GOAL_DL, createGoalDL),
    takeLatest(GET_CGOAL_DL, getCGoalDLSaga),
    takeLatest(DL_CHECKOUT, deeplinkChekoutSaga),
    takeLatest(GET_DEEPLINK_4_CONFIG, getDeeplink4ConfigSaga),
  ]);
}

